<template>
    <b-container fluid>
        <b-row class="mb-3">
            <b-col cols="12">
                <h3>Criteria Dictionary 관리</h3>
            </b-col>
            <b-col cols="12">
                <div class="text-left">
                    <h5>Criteria Dictionary 목록</h5>
                </div>
            </b-col>
            <b-col cols="12">
                <b-table
                    :items="dictionaries"
                    :fields="dictionaries_fields"
                    sticky-header="300px"
                    table-class="border-left border-right"
                    striped
                    hover
                    bordered
                    no-border-collapse
                    :busy="is_loading_dirctionaries || is_form_disabled"
                    >

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle mr-2"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </template>

                    <template #head(criteria_name)="data">
                        <div style="max-width: 175px;" class="text-center w-100">
                            {{ data.label }}
                        </div>
                    </template>

                    <template #cell(criteria_name)="data">
                        <div style="max-width: 175px;" class="w-100">
                            {{ data.value }}
                        </div>
                    </template>

                    <template #cell(theme)="data">
                        {{ theme_list_en[data.value] }}
                    </template>

                    <template #cell(in_dashboard)="data">
                        {{ !data.value ? '-' : '적용' }}
                    </template>

                    <template #cell(criteria_control)="data">
                        <b-btn
                            variant="secondary"
                            class="mr-2"
                            @click="editCriteriaDictionary(data.item.id)"
                            :disabled="is_create_edit_criteria_dictionary || is_delete_criteria_dictionary"
                            size="sm"
                            >
                            수정

                            <b-spinner v-show="is_create_edit_criteria_dictionary && create_edit_criteria_dictionary_target === data.item.id" small />
                        </b-btn>
                        <b-btn
                            variant="danger"
                            @click="deleteCriteriaDictionary(data.item.id)"
                            :disabled="(is_create_edit_criteria_dictionary || is_delete_criteria_dictionary)"
                            size="sm"
                            >
                            삭제
                            <b-spinner v-show="is_delete_criteria_dictionary && delete_criteria_dictionary_target === data.item.id" small />
                        </b-btn>
                    </template>
                </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-card id="criteria_dictionary_editor_form" no-body>
                    <b-card-header class="d-flex justify-content-between align-items-center">
                        <h5 class="mb-0">Criteria Dictionary 생성 및 편집</h5>
                    </b-card-header>
                    <b-card-body>
                        <b-form @submit.prevent="onSubmitCriteriaDictionary" @reset="onResetCrieriaDictionary">
                            <b-form-row class="mb-2">
                                <b-col cols="4">
                                    <b-form-group
                                        id="input-group-criteria_name"
                                        label="이름"
                                        label-for="input-criteria_name"
                                        class="mb-0"
                                        >
                                        <b-form-input
                                            id="input-criteria_name"
                                            v-model="criteriaDictForm.name"
                                            :disabled="is_form_disabled"
                                            placeholder="생성 및 수정 Criteria의 이름"
                                            required
                                            trim
                                            />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group
                                        id="input-group-criteria_category"
                                        label="카테고리"
                                        label-for="input-criteria_category"
                                        class="mb-0"
                                        >
                                        <b-form-select
                                            id="input-criteria_category"
                                            v-model="criteriaDictForm.selected_category"
                                            :options="criteriaDictForm.categories"
                                            :disabled="is_form_disabled"
                                            />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group
                                        id="input-group-criteria_theme"
                                        label="데이터 유형"
                                        label-for="input-criteria_theme"
                                        class="mb-0"
                                        >
                                        <b-form-select
                                            id="input-criteria_theme"
                                            v-model="criteriaDictForm.selected_theme"
                                            :options="criteriaDictForm.theme_list"
                                            :disabled="is_form_disabled"
                                            placeholder="측정 항목을 선택해주세요"
                                            required
                                            />
                                    </b-form-group>
                                </b-col>
                            </b-form-row>
                            <b-form-row class="mb-3">
                                <b-col cols="9">
                                    <b-form-group
                                        id="input-group-criteria_description"
                                        label="설명"
                                        label-for="input-criteria_description"
                                        class="mb-0"
                                        >
                                        <b-form-textarea
                                            id="input-criteria_description"
                                            v-model="criteriaDictForm.description"
                                            :disabled="is_form_disabled"
                                            placeholder="Criteria에 대한 설명"
                                            rows="2"
                                            max-rows="3"
                                        ></b-form-textarea>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="3">
                                    <b-form-group
                                        id="input-group-criteria_inDashboard"
                                        label="대시보드"
                                        label-for="input-criteria_inDashboard"
                                        class="mb-0"
                                        >
                                        <b-form-checkbox
                                            id="input-criteria_inDashboard"
                                            v-model="criteriaDictForm.in_dashboard"
                                            :disabled="is_form_disabled"
                                            >
                                            적용
                                        </b-form-checkbox>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>
                            <b-form-row>
                                <b-col cols class="text-right">
                                    <template v-if="is_create_edit_criteria_dictionary && create_edit_criteria_dictionary_target">
                                        <b-spinner small />
                                    </template>
                                    <template v-else>
                                        <b-btn
                                            type="submit"
                                            variant="primary"
                                            class="mr-2"
                                            :disabled="is_edited_dictionary_form || (is_create_edit_criteria_dictionary || is_delete_criteria_dictionary) || is_form_disabled">
                                            생성 및 수정하기
                                        </b-btn>
                                        <b-btn
                                            type="reset"
                                            variant="danger"
                                            :disabled="is_edited_dictionary_form || is_form_disabled"
                                            >
                                            취소
                                        </b-btn>
                                    </template>
                                </b-col>
                            </b-form-row>
                        </b-form>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import commonErrorHandling from '@core_mixins/common-error-handling-mixin.js';
import { getErrorMessage } from '@core/utils/api/errorMessage';

export default {
    name: 'EditingCriteriaDictionary',
    mixins: [
        commonErrorHandling
    ],
    data () {
        return {
            dictionaries: [],
            dictionaries_fields: [
                {
                    key: 'id',
                    sortable: true,
                    thClass: ['text-center'],
                    tdClass: ['text-center']
                },
                {
                    key: 'criteria_name',
                    label: '이름',
                    sortable: true,
                    thClass: ['text-center']
                },
                {
                    key: 'category',
                    label: '카테고리',
                    sortable: true,
                    thClass: ['text-center'],
                    tdClass: ['text-center']
                },
                {
                    key: 'theme',
                    label: '데이터',
                    sortable: true,
                    thClass: ['text-center'],
                    tdClass: ['text-center']
                },
                {
                    key: 'in_dashboard',
                    label: '대시보드',
                    sortable: true,
                    thClass: ['text-center'],
                    tdClass: ['text-center']
                },
                {
                    key: 'criteria_control',
                    label: '수정 및 삭제',
                    sortable: true,
                    thClass: ['text-center'],
                    tdClass: ['text-center']
                }
            ],
            theme_list_en: {
                num: '숫자',
                str: '텍스트',
                radio: '라디오 버튼'
            },
            criteriaDictForm: {
                id: null,
                name: null,
                description: null,
                selected_theme: null,
                theme_list: [
                    { text: '숫자', value: 'num' },
                    { text: '텍스트', value: 'str' },
                    { text: '라디오 버튼', value: 'radio' },
                ],
                selected_category: null,
                categories: [],
                in_dashboard: false
            },
            is_loading_categories: false,
            is_loading_dirctionaries: false,
            // criteria dictionary 관련 action status
            is_opened_criteria_dictionary: false,
            is_create_edit_criteria_dictionary: false,
            is_delete_criteria_dictionary: false,
            // criteria dictionary 관련 target element indicator
            create_edit_criteria_dictionary_target: null,
            delete_criteria_dictionary_target: null,
        }
    },
    computed: {
        is_edited_dictionary_form () {
            return !(!!this.criteriaDictForm.selected_theme || !!this.criteriaDictForm.name)
        },
        is_form_disabled () {
            return this.is_loading_categories
        }
    },
    watch: {},
    async created () {
        await Promise.all([this.getCriteriaCategory(), this.getCriteriaDictionaries()])
    },
    methods: {
        async getCriteriaCategory () {
            try {
                this.is_loading_categories = true
                const _res_category = await this.$axios.get('/parser/categories')
                this.criteriaDictForm.categories = _res_category.data.reduce((_categories, _category) => {
                    _categories.push({ text: `${_category.category_description} (${_category.category_name})`, value: _category.category_name })
                    return _categories
                }, [])
            } catch (error) {
                await this.common_error_handling(error, this.handlingErrorOnRead)
            } finally {
                this.is_loading_categories = false
            }
        },
        async getCriteriaDictionaries () {
            try {
                this.is_loading_dirctionaries = true
                const _res_dictionaries = await this.$axios.get('/parser/dictionaries')
                this.dictionaries = _res_dictionaries.data
            } catch (error) {
                await this.common_error_handling(error, this.handlingErrorOnRead)
            } finally {
                this.is_loading_dirctionaries = false
            }
        },
        handlingErrorOnRead (error) {
            if (error.response) {
                // 서버 메시지는 error.response.data.msg (data 를 거치지 않으면 항상 undefined)
                const msg = (error.response.data && error.response.data.msg) || getErrorMessage(error, '')
                alert(msg || 'Criteria 목록을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.')
            } else {
                alert('알수 없는 에러가 발생했습니다. 수정창을 닫은 후 재시도해주시 바랍니다.')
            }
        },
        /** 표 정렬과 무관하게 id 로 원본 위치를 찾는다 */
        findDictionaryIndex (dictionary_id) {
            return this.dictionaries.findIndex(_dictionary => String(_dictionary.id) === String(dictionary_id))
        },
        async editCriteriaDictionary (dictionary_id) {
            let _edit_target_dictionary = this.dictionaries[this.findDictionaryIndex(dictionary_id)]
            if (!_edit_target_dictionary) {
                this.$EventBus.$emit('toast-warning', 'Criteria 확인 필요', '일치하는 Criteria 를 찾을 수 없습니다. Criteria 목록을 다시 불러옵니다.')
                this.dictionaries = []
                await this.getCriteriaDictionaries()
                await this.onResetCrieriaDictionary()
                _edit_target_dictionary = null
            } else {
                this.criteriaDictForm = {
                    id: dictionary_id,
                    name: _edit_target_dictionary.criteria_name,
                    description: _edit_target_dictionary.description,
                    selected_category: _edit_target_dictionary.category,
                    in_dashboard: _edit_target_dictionary.in_dashboard,
                    selected_theme: _edit_target_dictionary.theme,
                    theme_list: this.criteriaDictForm.theme_list,
                    categories: this.criteriaDictForm.categories
                }
            }
        },
        async onSubmitCriteriaDictionary () {
            try {
                this.create_edit_criteria_dictionary_target = this.criteriaDictForm.id
                this.is_create_edit_criteria_dictionary = true
                
                let reqData = {
                    criteria_name: this.criteriaDictForm.name,
                    category: this.criteriaDictForm.selected_category,
                    theme: this.criteriaDictForm.selected_theme,
                    description: this.criteriaDictForm.description,
                    in_dashboard: this.criteriaDictForm.in_dashboard
                }
                if (this.criteriaDictForm.id) {
                    reqData.criteria_id = this.criteriaDictForm.id
                }
                
                let _created_criteria_form = await this.$axios.post('/parser/dictionaries', reqData)
                
                _created_criteria_form = _created_criteria_form.data
                if (this.criteriaDictForm.id) {
                    const _edited_dictionary_idx = this.dictionaries.findIndex(dictionary => dictionary.id.toString() === _created_criteria_form.id.toString())
                    if (_edited_dictionary_idx > -1) {
                        this.$set(this.dictionaries, _edited_dictionary_idx, _created_criteria_form)
                    }
                } else {
                    this.dictionaries.push(_created_criteria_form)
                }
                this.$EventBus.$emit('toast-success', '성공', 'Criteria 를 저장하였습니다.')
            } catch (error) {
                await this.common_error_handling(error, this.handlingErrorOnDictCreateUpdate)
            } finally {
                this.is_create_edit_criteria_dictionary = false
                this.create_edit_criteria_dictionary_target = null
            }
        },
        handlingErrorOnDictCreateUpdate (error) {
            if (error.response) {
                const msg = (error.response.data && error.response.data.msg) || getErrorMessage(error, '')
                alert(msg || 'Criteria 를 저장하지 못했습니다. 잠시 후 다시 시도해주세요.')
            } else {
                alert('알수 없는 에러가 발생했습니다. Criteria Dictionary 창을 닫은 후 재시도해주시 바랍니다.')
            }
        },
        async deleteCriteriaDictionary (dictionary_id) {
            try {
                this.is_delete_criteria_dictionary = true
                this.delete_criteria_dictionary_target = dictionary_id
                const _delete_target_dictionary = this.dictionaries[this.findDictionaryIndex(dictionary_id)]
                if (!_delete_target_dictionary) {
                    this.$EventBus.$emit('toast-warning', 'Criteria 확인 필요', '일치하는 Criteria 를 찾을 수 없습니다. Criteria 목록을 다시 불러옵니다.')
                    this.dictionaries = []
                    await this.getCriteriaDictionaries()
                } else {
                    const _confirmed_delete_criteria_dictionary = await this.$showModal({
                        type: 'confirm',
                        state: 'error',
                        title: 'Criteria 삭제',
                        message: `${_delete_target_dictionary.criteria_name} Criteria 를 삭제합니다. 되돌릴 수 없습니다.`
                    })
                    if (_confirmed_delete_criteria_dictionary) {
                        await this.$axios.delete('/parser/dictionaries', { data: { criteria_id: _delete_target_dictionary.id } })
                        // 요청 중에 목록이 바뀌었을 수 있어 지울 때 다시 찾는다
                        const _deleted_idx = this.findDictionaryIndex(dictionary_id)
                        if (_deleted_idx > -1) this.dictionaries.splice(_deleted_idx, 1)
                    }
                }
                await this.onResetCrieriaDictionary()
            } catch (error) {
                this.common_error_handling(error, this.handlingErrorOnDelete)
            } finally {
                this.is_delete_criteria_dictionary = false
                this.delete_criteria_dictionary_target = null
            }
        },
        handlingErrorOnDelete (error) {
            // 401 은 공통 처리(로그인 이동)에 맡긴다
            if (error.response && error.response.status !== 401) {
                const data = error.response.data || {}
                let error_message = getErrorMessage(error, '')

                if (data.def_pd) {
                    let referred_sub_codes = data.def_pd.reduce((_refer_subs, def) => {
                        _refer_subs.push(def.sub_code)
                        return _refer_subs
                    }, [])

                    if (referred_sub_codes.length) {
                        referred_sub_codes = referred_sub_codes.join(', ')
                        error_message += ` 참조하고 있는 sub_code는 ${referred_sub_codes} 입니다.`
                    }
                }
                
                
                if (typeof data.msg === 'string' && data.msg.includes('유효한 값을 입력해주세요.')) {
                    error_message += ` criteria id는 ${this.delete_criteria_dictionary_target} 입니다.`
                }

                this.$EventBus.$emit('toast-failure', 'Criteria 삭제 실패', error_message || 'Criteria 를 삭제하지 못했습니다. 잠시 후 다시 시도해 주세요.')
            }
        },
        async onResetCrieriaDictionary () {
            this.criteriaDictForm = {
                id: null,
                name: null,
                description: null,
                selected_theme: null,
                theme_list: [
                    { text: '숫자', value: 'num' },
                    { text: '텍스트', value: 'str' },
                    { text: '라디오 버튼', value: 'radio' },
                ],
                selected_category: null,
                categories: [],
                in_dashboard: false
            }

            await this.getCriteriaCategory()
        }
    }
}
</script>

<style></style>